import { docNormalizer, cnpjNormalizer, cpfNormalizer, numberNormalizer } from "../util";

export const TAX_DOCUMENT_TYPES = {
  SELECT: { value: "", input: "app.form.selectTaxResidence" },
  STEUER_ID: { value: "STEUER_ID", input: "app.steuerId" }, //alemanha
  STEUERNUMMER_FUR_AUSLANDER: { value: "STEUERNUMMER_FUR_AUSLANDER", input: "app.steuernummerFurAuslander" }, //alemanha
  STEUERNUMMER: { value: "STEUERNUMMER", input: "app.steuernummer" }, //alemanha
  UMSATZSTEUER_IDENTIFIKATIONSNUMMER: { value: "UMSATZSTEUER_IDENTIFIKATIONSNUMMER", input: "app.umsatzsteuerIdentifikationsnummer" }, //alemanha
  CUIT: { value: "CUIT", input: "app.cuit" }, //argentina
  TFN: { value: "TFN", input: "app.tfn" }, //australia
  ABN: { value: "ABN", input: "app.abn" }, //australia
  RIJKSREGISTERNUMMER: { value: "RIJKSREGISTERNUMMER", input: "app.rijksregisternummer" }, //bélgica
  ENTREPRISE_NUMMER: { value: "ENTREPRISE_NUMMER", input: "app.entrepriseNummer" }, //bélgica
  KBO_BCE: { value: "KBO_BCE", input: "app.kboBce" }, //bélgica
  NIF: { value: "NIF", input: "app.nif" }, //bélgica, luxemburgo, portugal
  CPF: { value: "CPF", input: "app.cpf" }, //brasil
  CNPJ: { value: "CNPJ", input: "app.cnpj" }, //brasil
  RUT: { value: "RUT", input: "app.rut" }, //chile, uruguai
  NIT: { value: "NIT", input: "app.nit" }, //colombia
  NITE: { value: "NITE", input: "app.nite" }, //costa rica
  RUC: { value: "RUC", input: "app.ruc" }, //equador, panama, peru
  EMIRATES_ID: { value: "EMIRATES_ID", input: "app.emiratesID" }, //Emirados Árabes
  EMIRATES_PASSPORT: { value: "EMIRATES_PASSPORT", input: "app.emiratesPassport" }, //Emirados Árabes
  SSN: { value: "SSN", input: "app.ssn" }, //eua
  EIN: { value: "EIN", input: "app.ein" }, //eua
  DNI: { value: "DNI", input: "app.dni" }, //espanha && peru
  NIE: { value: "NIE", input: "app.nie" }, //espanha
  TIE: { value: "TIE", input: "app.tie" }, //espanha
  AFM: { value: "AFM", input: "app.afm" }, //grécia
  CNI: { value: "CNI", input: "app.cni" }, //frança
  TITRE_SEJOUR: { value: "TITRE_SEJOUR", input: "app.titreSejour" }, //frança
  SIREN: { value: "SIREN", input: "app.siren" }, //frança
  SIRET: { value: "SIRET", input: "app.siret" }, //frança
  TIN: { value: "TIN", input: "app.tin" }, //chipre, grécia
  COMPANY_REGISTRATION_NUMBER: { value: "COMPANY_REGISTRATION_NUMBER", input: "app.companyRegistrationNumber" }, //chipre, Emirados Árabes
  SIN: { value: "SIN", input: "app.sin" }, //guernsey
  GCRN: { value: "GCRN", input: "app.gcrn" }, //guernsey
  TAJ: { value: "TAJ", input: "app.taj" }, //hungria
  ADOSZAM: { value: "ADOSZAM", input: "app.adoszam" }, //hungria
  CEGJEGYZEKSZAM: { value: "CEGJEGYZEKSZAM", input: "app.cegjegyzekszam" }, //hungria
  PAN: { value: "PAN", input: "app.pan" }, //india
  GSTIN: { value: "GSTIN", input: "app.gstin" }, //india
  PPS: { value: "PPS", input: "app.pps" }, //irlanda
  IRP: { value: "IRP", input: "app.irp" }, //irlanda
  CRN: { value: "CRN", input: "app.crn" }, //irlanda
  CF: { value: "CF", input: "app.cf" }, //italia
  PARTITA_IVA: { value: "PARTITA_IVA", input: "app.partitaIva" }, //italia
  NUMERO_DE_CONTRIBUABLE: { value: "NUMERO_DE_CONTRIBUABLE", input: "app.numeroDeContribuable" }, //luxemburgo
  REGISTRE_DE_COMMERCE: { value: "REGISTRE_DE_COMMERCE", input: "app.registreDeCommerce" }, //luxemburgo
  RFC: { value: "RFC", input: "app.rfc" }, //mexico
  IRD: { value: "IRD", input: "app.ird" }, //nova zelandia
  NZBN: { value: "NZBN", input: "app.nzbn" }, //nova zelandia
  BSN: { value: "BSN", input: "app.bsn" }, //paises baixos
  KVK: { value: "KVK", input: "app.kvk" }, //paises baixos
  BTW: { value: "BTW", input: "app.btw" }, //paises baixos
  CARNE_DE_EXTRANJERIA: { value: "CARNE_DE_EXTRANJERIA", input: "app.carneDeExtranjeria" }, //peru
  NIPC: { value: "NIPC", input: "app.nipc" }, //portugal
  NIN: { value: "NIN", input: "app.nin" }, //reino unido
  BRP: { value: "BRP", input: "app.brp" }, //reino unido
  UTR: { value: "UTR", input: "app.utr" }, //reino unido
  PERSONNUMMER: { value: "PERSONNUMMER", input: "app.personnummer" }, //suécia
  SKATTEIDENTIFIKATIONSNUMMER: { value: "SKATTEIDENTIFIKATIONSNUMMER", input: "app.skatteidentifikationsnummer" }, //suécia
  UTLANDSKT_SKATTEREGISTRERINGSNUMMER: { value: "UTLANDSKT_SKATTEREGISTRERINGSNUMMER", input: "app.utlandsktSkatteregistreringsnummer" }, //suécia
  ORGANISATIONSNUMMER: { value: "ORGANISATIONSNUMMER", input: "app.organisationsnummer" }, //suécia
  UID: { value: "UID", input: "app.uid" }, //suíça
  VAT: { value: "VAT", input: "app.vat" }, //suíça
  RIF: { value: "RIF", input: "app.rif" }, //venezuela
};

export const NORMALIZER_BY_DOCUMENT_TYPE = {
  CPF: cpfNormalizer,
  CNPJ: cnpjNormalizer,
  CUIT: numberNormalizer,
  TFN: numberNormalizer,
  ABN: numberNormalizer,
  RUT: numberNormalizer,
  NIT: numberNormalizer,
  NITE: numberNormalizer,
  SSN: numberNormalizer,
  EIN: numberNormalizer,
  RUC: numberNormalizer,
  SIN: numberNormalizer,
  GCRN: numberNormalizer,
  PAN: numberNormalizer,
  GSTIN: numberNormalizer,
  RFC: numberNormalizer,
  IRD: numberNormalizer,
  NZBN: numberNormalizer,
  NIF: numberNormalizer,
  NIPC: numberNormalizer,
  RIF: numberNormalizer,
  DNI: docNormalizer,
  NIE: docNormalizer,
  TIE: docNormalizer,
  CNI: docNormalizer,
  TITRE_SEJOUR: docNormalizer,
  SIREN: docNormalizer,
  SIRET: docNormalizer,
  NIN: docNormalizer,
  BRP: docNormalizer,
  UTR: docNormalizer,
  PPS: docNormalizer,
  IRP: docNormalizer,
  CRN: docNormalizer,
  UID: docNormalizer,
  VAT: docNormalizer,
  CF: docNormalizer,
  PARTITA_IVA: docNormalizer,
  STEUER_ID: docNormalizer,
  STEUERNUMMER_FUR_AUSLANDER: docNormalizer,
  STEUERNUMMER: docNormalizer,
  UMSATZSTEUER_IDENTIFIKATIONSNUMMER: docNormalizer,
  AFM: docNormalizer,
  TIN: docNormalizer,
  BSN: docNormalizer,
  KVK: docNormalizer,
  BTW: docNormalizer,
  RIJKSREGISTERNUMMER: docNormalizer,
  ENTREPRISE_NUMMER: docNormalizer,
  KBO_BCE: docNormalizer,
  TAJ: docNormalizer,
  ADOSZAM: docNormalizer,
  CEGJEGYZEKSZAM: docNormalizer,
  COMPANY_REGISTRATION_NUMBER: docNormalizer,
  NUMERO_DE_CONTRIBUABLE: docNormalizer,
  REGISTRE_DE_COMMERCE: docNormalizer,
  PERSONNUMMER: docNormalizer,
  SKATTEIDENTIFIKATIONSNUMMER: docNormalizer,
  UTLANDSKT_SKATTEREGISTRERINGSNUMMER: docNormalizer,
  ORGANISATIONSNUMMER: docNormalizer,
  EMIRATES_ID: numberNormalizer,
  EMIRATES_PASSPORT: numberNormalizer,
  CARNE_DE_EXTRANJERIA: docNormalizer,
};

export const TAX_DOCUMENT_TYPES_BY_RESIDENCE = {
  Argentina: {
    pf: [TAX_DOCUMENT_TYPES.CUIT],
    pj: [TAX_DOCUMENT_TYPES.CUIT],
  },
  Austrália: {
    pf: [TAX_DOCUMENT_TYPES.TFN],
    pj: [TAX_DOCUMENT_TYPES.ABN],
  },
  Brasil: {
    pf: [TAX_DOCUMENT_TYPES.CPF],
    pj: [TAX_DOCUMENT_TYPES.CNPJ],
  },
  Colômbia: {
    pf: [TAX_DOCUMENT_TYPES.NIT],
    pj: [TAX_DOCUMENT_TYPES.NIT],
  },
  Uruguai: {
    pf: [TAX_DOCUMENT_TYPES.RUT],
    pj: [TAX_DOCUMENT_TYPES.RUT],
  },
  Portugal: {
    pf: [TAX_DOCUMENT_TYPES.NIF],
    pj: [TAX_DOCUMENT_TYPES.NIPC],
  },
  Chile: {
    pf: [TAX_DOCUMENT_TYPES.RUT],
    pj: [TAX_DOCUMENT_TYPES.RUT],
  },
  Venezuela: {
    pf: [TAX_DOCUMENT_TYPES.RIF],
    pj: [TAX_DOCUMENT_TYPES.RIF],
  },
  México: {
    pf: [TAX_DOCUMENT_TYPES.RFC],
    pj: [TAX_DOCUMENT_TYPES.RFC],
  },
  Equador: {
    pf: [TAX_DOCUMENT_TYPES.RUC],
    pj: [TAX_DOCUMENT_TYPES.RUC],
  },
  Índia: {
    pf: [TAX_DOCUMENT_TYPES.PAN],
    pj: [TAX_DOCUMENT_TYPES.GSTIN],
  },
  "Nova Zelândia": {
    pf: [TAX_DOCUMENT_TYPES.IRD],
    pj: [TAX_DOCUMENT_TYPES.NZBN],
  },
  Panamá: {
    pf: [TAX_DOCUMENT_TYPES.RUC],
    pj: [TAX_DOCUMENT_TYPES.RUC],
  },
  EUA: {
    pf: [TAX_DOCUMENT_TYPES.SSN],
    pj: [TAX_DOCUMENT_TYPES.EIN],
  },
  "Costa Rica": {
    pf: [TAX_DOCUMENT_TYPES.NITE],
    pj: [TAX_DOCUMENT_TYPES.NITE],
  },
  Guernsey: {
    pf: [TAX_DOCUMENT_TYPES.SIN],
    pj: [TAX_DOCUMENT_TYPES.GCRN],
  },
  Espanha: {
    pf: [TAX_DOCUMENT_TYPES.DNI, TAX_DOCUMENT_TYPES.NIE, TAX_DOCUMENT_TYPES.TIE],
    pj: [TAX_DOCUMENT_TYPES.NIF],
  },
  França: {
    pf: [TAX_DOCUMENT_TYPES.CNI, TAX_DOCUMENT_TYPES.TITRE_SEJOUR],
    pj: [TAX_DOCUMENT_TYPES.SIREN, TAX_DOCUMENT_TYPES.SIRET],
  },
  "Reino Unido": {
    pf: [TAX_DOCUMENT_TYPES.NIN, TAX_DOCUMENT_TYPES.BRP],
    pj: [TAX_DOCUMENT_TYPES.UTR],
  },
  Irlanda: {
    pf: [TAX_DOCUMENT_TYPES.PPS, TAX_DOCUMENT_TYPES.IRP],
    pj: [TAX_DOCUMENT_TYPES.CRN],
  },
  Suíça: {
    pf: [TAX_DOCUMENT_TYPES.SSN],
    pj: [TAX_DOCUMENT_TYPES.UID, TAX_DOCUMENT_TYPES.VAT],
  },
  Itália: {
    pf: [TAX_DOCUMENT_TYPES.CF],
    pj: [TAX_DOCUMENT_TYPES.PARTITA_IVA],
  },
  Alemanha: {
    pf: [TAX_DOCUMENT_TYPES.STEUER_ID, TAX_DOCUMENT_TYPES.STEUERNUMMER_FUR_AUSLANDER],
    pj: [TAX_DOCUMENT_TYPES.STEUERNUMMER, TAX_DOCUMENT_TYPES.UMSATZSTEUER_IDENTIFIKATIONSNUMMER],
  },
  Grécia: {
    pf: [TAX_DOCUMENT_TYPES.AFM],
    pj: [TAX_DOCUMENT_TYPES.TIN],
  },
  "Países Baixos": {
    pf: [TAX_DOCUMENT_TYPES.BSN],
    pj: [TAX_DOCUMENT_TYPES.KVK, TAX_DOCUMENT_TYPES.BTW],
  },
  Bélgica: {
    pf: [TAX_DOCUMENT_TYPES.RIJKSREGISTERNUMMER, TAX_DOCUMENT_TYPES.NIF],
    pj: [TAX_DOCUMENT_TYPES.ENTREPRISE_NUMMER, TAX_DOCUMENT_TYPES.KBO_BCE],
  },
  Hungria: {
    pf: [TAX_DOCUMENT_TYPES.TAJ],
    pj: [TAX_DOCUMENT_TYPES.ADOSZAM, TAX_DOCUMENT_TYPES.CEGJEGYZEKSZAM],
  },
  Chipre: {
    pf: [TAX_DOCUMENT_TYPES.TIN],
    pj: [TAX_DOCUMENT_TYPES.TIN, TAX_DOCUMENT_TYPES.COMPANY_REGISTRATION_NUMBER],
  },
  Luxemburgo: {
    pf: [TAX_DOCUMENT_TYPES.NIF, TAX_DOCUMENT_TYPES.NUMERO_DE_CONTRIBUABLE],
    pj: [TAX_DOCUMENT_TYPES.NIF, TAX_DOCUMENT_TYPES.REGISTRE_DE_COMMERCE],
  },
  Suécia: {
    pf: [TAX_DOCUMENT_TYPES.PERSONNUMMER, TAX_DOCUMENT_TYPES.SKATTEIDENTIFIKATIONSNUMMER, TAX_DOCUMENT_TYPES.UTLANDSKT_SKATTEREGISTRERINGSNUMMER],

    pj: [TAX_DOCUMENT_TYPES.ORGANISATIONSNUMMER, TAX_DOCUMENT_TYPES.SKATTEIDENTIFIKATIONSNUMMER],
  },
  "Emirados Árabes": {
    pf: [TAX_DOCUMENT_TYPES.EMIRATES_ID, TAX_DOCUMENT_TYPES.EMIRATES_PASSPORT],
    pj: [TAX_DOCUMENT_TYPES.COMPANY_REGISTRATION_NUMBER],
  },
  Peru: {
    pf: [TAX_DOCUMENT_TYPES.DNI, TAX_DOCUMENT_TYPES.CARNE_DE_EXTRANJERIA],
    pj: [TAX_DOCUMENT_TYPES.RUC],
  },
  Paraguai: {
    pf: [TAX_DOCUMENT_TYPES.RUC],
    pj: [TAX_DOCUMENT_TYPES.RUC],
  },
};

export const getTaxDocumentTypes = (taxResidence, personType = "NATURAL_PERSON") => {
  const normalizedPersonType = personType === "COMPANY" ? "pj" : "pf";
  return TAX_DOCUMENT_TYPES_BY_RESIDENCE[taxResidence]?.[normalizedPersonType] || [];
};
